import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { AppState } from '@app/Store/reducers';
import { dashboardFeatureSelectors } from '@app/Store/features/dashboard.feature';
import { iParsedEntity } from '@app/Shared/interfaces/iEntityParsed';
import { DashboardActions } from '@app/Store';

@Component({
    selector: 'app-new-data-explorer-details-panel',
    templateUrl: './new-data-explorer-details-panel.component.html',
    styleUrls: ['./new-data-explorer-details-panel.component.scss'],
})
export class NewDataExplorerDetailsPanelComponent implements OnInit, OnDestroy {
    @Input() isFullscreen = false;
    @Output() toggleFullscreen = new EventEmitter<void>();

    // Tab management
    public selectedTab = 'EditRow';
    public tabs = [
        { id: 'EditRow', label: 'Edit Row', active: true, icon: 'edit' },
        { id: 'Dedup', label: 'Dedup', active: false, icon: 'find_replace' },
        { id: 'Relations', label: 'Relations', active: false, icon: 'account_tree' },
        { id: 'Sources', label: 'Sources', active: false, icon: 'source' },
        { id: 'MapIt', label: 'MapIt', active: false, icon: 'map' },
        { id: 'Refresh', label: 'Refresh', active: false, icon: 'refresh' },
        { id: 'ChatIT', label: 'ChatIT', active: false, icon: 'chat' },
    ];

    // Selected entity
    public selectedEntity: iParsedEntity | null = null;

    private subscription: Subscription = new Subscription();

    constructor(private store: Store<AppState>) {}

    ngOnInit(): void {
        // Subscribe to selected entity
        this.subscription.add(
            this.store
                .pipe(
                    select(dashboardFeatureSelectors.selectSelectedEntity),
                    distinctUntilChanged((prev, curr) => prev?.entityName === curr?.entityName),
                )
                .subscribe((entity) => {
                    this.selectedEntity = entity;
                }),
        );

        // Subscribe to tab changes from store
        this.subscription.add(
            this.store.pipe(select(dashboardFeatureSelectors.selectTabChange), distinctUntilChanged()).subscribe((tab) => {
                if (tab && this.tabs.find((t) => t.id === tab)) {
                    this.selectTab(tab);
                }
            }),
        );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    onToggleFullscreen(): void {
        this.toggleFullscreen.emit();
    }

    // Tab management
    selectTab(tabId: string): void {
        this.tabs.forEach((tab) => {
            tab.active = tab.id === tabId;
        });
        this.selectedTab = tabId;
        // Dispatch action to store to sync tab selection
        this.store.dispatch(DashboardActions.changeSelectedTab({ selectedTab: tabId }));
    }

    // Get active tab index for CSS variable
    getActiveTabIndex(): number {
        return this.tabs.findIndex((tab) => tab.active);
    }
}
